
import { db } from '@/services/firebase';
import { collection, addDoc } from 'firebase/firestore';
import { fakerPT_BR as faker } from '@faker-js/faker';

// Goal: 5 Pousadas, 5 Barcos, 5 Operadores

// Types
type Category = 'pousada' | 'barco_hotel' | 'operacao';

const CATEGORIES: Category[] = ['pousada', 'barco_hotel', 'operacao'];

export async function seed(onLog: (msg: string) => void) {
    onLog("🌱 Starting Seeding Process...");
    
    for (const cat of CATEGORIES) {
        onLog(`\n--- Seeding Category: ${cat} ---`);
        for (let i = 0; i < 5; i++) {
            await createCompany(cat, i, onLog);
        }
    }
    
    onLog("\n✅ Seeding Complete!");
}

async function createCompany(type: Category, index: number, onLog: (msg: string) => void) {
    const name = faker.company.name();
    const suffix = type === 'pousada' ? 'Pousada' : type === 'barco_hotel' ? 'Barco' : 'Sport Fishing';
    const companyName = `${name} ${suffix}`;
    
    onLog(`Creating ${companyName}...`);
    
    const tenantRequest = {
        businessName: companyName, // Field name from TenantRequest interface in List component
        category: type,
        status: 'approved',
        email: faker.internet.email(),
        phone: faker.phone.number(),
        city: faker.location.city(),
        state: faker.location.state({ abbreviated: true }),
        requestDate: new Date().toISOString().split('T')[0],
        contactName: faker.person.fullName(),
        createdAt: new Date(),
        updatedAt: new Date()
    };
    
    try {
        // We write to 'tenant_requests' collection? Or just 'tenants'?
        // Assuming 'tenant_requests' for now based on dashboard context
        await addDoc(collection(db, 'tenant_requests'), tenantRequest);
        onLog(`   -> Tenant Request Created: ${tenantRequest.businessName}`);
    } catch (e: any) {
        onLog(`   ❌ Error creating tenant: ${e.message}`);
    }
    
    // Site Config (simulated)
    const siteConfig = {
        siteName: companyName,
        domain: `${faker.internet.domainWord()}.nossapesca.com`,
        theme: {
            primary: faker.color.rgb(),
            secondary: faker.color.rgb()
        }
    };
    onLog(`   -> Site Configured: ${siteConfig.domain}`);
}

export const runSeeder = async (onLog: (msg: string) => void) => {
    await seed(onLog);
};
